import * as monacoEditor from 'monaco-editor/esm/vs/editor/editor.api';

import { graphqlLanguageConfiguration } from '../../explorerPage/operationsPane/graphqlEditor/graphqlLanguageConfiguration';
import { graphqlTokensProvider } from '../../explorerPage/operationsPane/graphqlEditor/graphqlTokensProvider';

export const registerGraphQLLanguage = () => {
  monacoEditor.languages.register({
    id: 'graphql',
    extensions: ['.graphql', '.gql'],
    aliases: ['GraphQL', 'graphql', 'gql'],
    mimetypes: ['application/graphql'],
  });

  monacoEditor.languages.setTokensProvider('graphql', graphqlTokensProvider);
  monacoEditor.languages.setLanguageConfiguration(
    'graphql',
    graphqlLanguageConfiguration,
  );
};
